// "12.5" -> "12.50"; whole pounds and anything non-numeric (e.g. "12 | 45") are left as written.
export const money = (p) => (/^\d+\.\d$/.test(String(p)) ? `${p}0` : p);
